import type { Brand } from './parse-brand';
import { deriveAccentVars } from './brand-color';

// Login e primeiro acesso sempre usam o tema dark do :root; a área logada sobrescreve via themeVars.
export function applyBrandToRoot(root: HTMLElement, brand: Pick<Brand, 'color' | 'fontFamily'>): void {
  for (const [name, value] of Object.entries(deriveAccentVars(brand.color).dark)) {
    root.style.setProperty(name, value);
  }
  root.style.setProperty('--font-sans', brand.fontFamily);
  root.style.setProperty('--font-family', brand.fontFamily);
  // O tema do PrimeReact escreve `:root { font-family: "Inter var" }` direto; essa regra vence o
  // `html { font-family: var(--font-sans) }` do index.css (especificidade), então o corpo do app
  // ficaria na Inter. O estilo inline no elemento raiz é o que a supera.
  root.style.fontFamily = brand.fontFamily;
}
